<template>
<div class="c-text-card">
    <div
        :class="['c-text-card__title', cStep >= 4 ? 'c-d-between' : '', customColor ]"
        :style="
            'font-family: ' + (isComda ? 'Open Sans' : 'museo') + ', serif;' +
            'color: ' + (isComda ? '#0a72ba' : '#009444') + ';'
        "
    >
        <div>{{ textCardTitle }}</div>
        <template v-if="cStep >= 4">
            <div>
                <button :class="['cbtn-imprint-comeback', customBackground]" @click="back()">Back to Imprint Selection</button>
            </div>
        </template>
    </div>
    <div :class="['c-text-card__body', cStep==1 || cStep==3 ||  cStep==4 || cStep==2 && isCustomBundlePage ?'add-line':'']" :style="cStep === 2 && !isCustomBundlePage ? 'border-bottom: 0' : ''">
      <p v-html="textCardBody" class="imprint-text"></p>
      <p v-if="additionalText" v-html="additionalText" class="imprint-text additional"></p>

        <div class="mobile-title c-text-card__title" v-if="cStep==2" >{{ textCardTitle.replace('Choose' ,'') }}</div>
    </div>
</div>
</template>

<script>

import {store} from "@/components/store";

export default {
    props: {
        textCardTitle: String,
        textCardBody: String,
        additionalText: String,
        cStep: Number,
        isCustomBundlePage: Boolean
    },
    methods: {
        back() {
            this.$emit("backToParent");
        }
    },
    computed: {
        isComda(){
          return store.storeID.includes('comda');
        },
        customColor() {
            return this.$getCustomColorClass(store.storeID);
        },
        customFont() {
            return this.$getCustomFontClass(store.storeID);
        },
        customBackground() {
            return this.$getCustomBackgroundColorClass(store.storeID);
        }
    }
}

</script>

<style>
 .c-text-card .c-text-card__title {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    padding-bottom: 5px;
    font-family: 'museo', serif;
 }

 .c-text-card .c-text-card__body {
    font-family: 'museo-sans', sans-serif;
    text-align: left;
    font-size: 12px;
    color:#5A5A5A;
    /*border-bottom: 1px solid #000;*/
    padding-bottom: 0;
    font-weight: 300;
    line-height: 18px;
 }

 .cbtn-imprint-comeback {
    cursor: pointer;
    color: white;
    border: 2px solid #d7d7d7;
    padding: 3px 10px;
    border-radius: 5px;
    font-weight: 300;
    font-size: 10px;
 }
 .c-text-card .c-text-card__body a {
   color: #0054a3
 }

 .c-text-card .c-text-card__body a:hover {
   color:#969696;
   text-decoration: underline;
 }

 .c-text-card__body.add-line{
   border-bottom: 1px solid #000;
 }
 .imprint-text.additional{
     padding-top: 0;
 }


</style>